// @flow
import React, { Component } from 'react'
import _ from 'lodash'
import styled, { type StyledComponent } from 'styled-components'
import LabeledWrapper from './LabeledWrapper'
import HintWrapper from '../controls/HintWrapper'
import Button from '../controls/PrimaryButton'
import AddParametersGroupBlock from './AddParametersGroupBlock'
import type { GroupedStringParameters } from '../types'
import { StyledAutoSizeTextArea } from './AdditionalParamsTextArea'

const Wrapper: StyledComponent<Object, any, any> = styled.div`
  padding-top: 10px;
`

type Props = {|
  keywordsGroups: Array<GroupedStringParameters>,
  errors: Array<string>,
  allowAdding: boolean,
  onChange: Function,
  onKeywordGroupAdd: Function,
  onKeywordGroupRemove: Function
|}

const t = {
  add: 'Добавить группу',
  label: 'Ключевые слова',
  hint:
    'Ключевые слова будут использованы как дополнительное ограничение целевой аудитории в сетях Google и myTarget',
  placeholder: 'По одному ключу на строку'
}

export default class KeywordsTextArea extends Component<Props> {
  render() {
    return (
      <LabeledWrapper label={this.renderLabelBlock()} errors={this.props.errors} twoLines>
        {_.map(this.props.keywordsGroups, (group, index: number) => {
          return (
            <Wrapper key={index} className={`t-KeywordsGroup_${index}`}>
              <StyledAutoSizeTextArea
                id={`audience_keywords_${index}`}
                className="input-item"
                value={group.value}
                maxRows={5}
                placeholder={t.placeholder}
                onChange={(e) => {
                  const newKeywordsGroups = _.cloneDeep(this.props.keywordsGroups)
                  newKeywordsGroups[index].value = e.target.value
                  this.props.onChange(newKeywordsGroups)
                }}
              />
              {this.props.keywordsGroups.length > 1 && (
                <AddParametersGroupBlock
                  index={index}
                  groups={this.props.keywordsGroups}
                  currentGroup={group}
                  inputName={`audience_keyword_group_name_${index}`}
                  inputValue={group.name}
                  onChange={(groups) => this.props.onChange(groups)}
                  onGroupRemove={(groups) => this.props.onKeywordGroupRemove(groups)}
                />
              )}
            </Wrapper>
          )
        })}
        {this.props.allowAdding && (
          <Wrapper>
            <Button
              className="t-KeywordsGroupAddButton"
              small
              onClick={() => {
                this.props.onChange(_.concat(this.props.keywordsGroups, { value: '', name: '' }))
                this.props.onKeywordGroupAdd()
              }}
            >
              {t.add}
            </Button>
          </Wrapper>
        )}
      </LabeledWrapper>
    )
  }

  renderLabelBlock() {
    return <HintWrapper triggerText={t.label} popupText={t.hint} alignLeft />
  }
}
